import React from 'react';
import { Avatar, Typography, Tooltip } from 'antd';
import { UserOutlined } from '@ant-design/icons';

const { Text } = Typography;

export const useUserAvatarRender = (
  size: 'small' | 'default' | 'large' = 'default'
) => {
  return React.useCallback(
    (user: any) => {
      if (!user?.first_name && !user?.last_name) {
        return '-';
      }

      const userName = `${user.first_name} ${user.last_name}`;

      // Extract initials from name
      const getInitials = (name: string) => {
        return name
          .split(' ')
          .map(word => word.charAt(0))
          .join('')
          .toUpperCase()
          .slice(0, 2);
      };

      // Generate consistent color based on name
      const getAvatarColor = (name: string) => {
        const pastelColors = [
          { bg: '#FFD3B6', text: '#5C2E00' }, // soft peach
          { bg: '#B5EAD7', text: '#004D40' }, // mint green
          { bg: '#C7CEEA', text: '#2C2F5C' }, // periwinkle
          { bg: '#FFDAC1', text: '#5E3929' }, // apricot
          { bg: '#E0BBE4', text: '#4A235A' }, // lavender
          { bg: '#D5AAFF', text: '#3B1C66' }, // light violet
          { bg: '#FDCB82', text: '#4D270C' }, // yellow-orange
          { bg: '#A0E7E5', text: '#003636' }, // aqua
          { bg: '#FFABAB', text: '#5E1D1D' }, // rose
          { bg: '#D0F4DE', text: '#0B3D2C' }, // soft green
          { bg: '#FFB6C1', text: '#4A2C2A' }, // light pink
          { bg: '#B0E0E6', text: '#1A3C3C' }, // powder blue
          { bg: '#F0E68C', text: '#4A3C00' }, // khaki
          { bg: '#98FB98', text: '#2F4F2F' }, // pale green
          { bg: '#E6E6FA', text: '#2F2F4F' }, // lavender blush
        ];

        let hash = 0;
        for (let i = 0; i < name.length; i++) {
          hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }

        const index = Math.abs(hash) % pastelColors.length;
        return pastelColors[index];
      };
      const initials = getInitials(userName);
      const avatarColor = getAvatarColor(userName);

      return (
        <Tooltip title={`${userName}`} placement="top">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              // justifyContent: 'center',
              gap: 8,
            }}
          >
            <Avatar
              size={size === 'small' ? 25 : size === 'large' ? 45 : 35}
              style={{
                backgroundColor: avatarColor.bg,
                color: avatarColor.text,
                fontWeight: 600,
                fontSize:
                  size === 'small'
                    ? '10px'
                    : size === 'large'
                      ? '14px'
                      : '12px',
              }}
            >
              {initials}
            </Avatar>
          </div>
        </Tooltip>
      );
    },
    [size]
  );
};
